module.exports = __webpack_public_path__ + "img/PXL_20230525_095217101.c280ea83.jpg";